import { openBlock as r, createElementBlock as t, createElementVNode as e } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function n(c, l) {
  return r(), t("svg", o, [...l[0] || (l[0] = [
    e("mask", {
      id: "a",
      fill: "#fff"
    }, [
      e("path", { d: "M12 13c4.113 0 7.504 3.054 8 7H4c.496-3.946 3.887-7 8-7" })
    ], -1),
    e("path", {
      fill: "currentColor",
      d: "M12 13v-1zm8 7v1h1.134l-.142-1.125zM4 20l-.992-.125L2.866 21H4zm8-7v1c3.608 0 6.574 2.678 7.008 6.125L20 20l.992-.125C20.433 15.43 16.617 12 12 12zm8 7v-1H4v2h16zM4 20l.992.125C5.426 16.678 8.392 14 12 14v-2c-4.617 0-8.433 3.43-8.992 7.875z",
      mask: "url(#a)"
    }, null, -1),
    e("circle", {
      cx: "11.935",
      cy: "7",
      r: "3.5",
      stroke: "currentColor"
    }, null, -1)
  ])]);
}
const a = { render: n };
export {
  a as default,
  n as render
};
